import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sign_form custom_scroll" }
const _hoisted_4 = { class: "imp" }
const _hoisted_5 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, "액션 시민 " + _toDisplayString($setup.props.isEdit ? "수정" : "추가"), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "group_title",
              class: "form_li_tit"
            }, "닉네임", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "group_title",
              type: "text",
              placeholder: "닉네임을 입력하세요",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form_state.nickname) = $event))
            }, null, 512), [
              [_vModelText, $setup.form_state.nickname]
            ])
          ])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "submit_btn _130 _gray",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
          }, "닫기"),
          _createElementVNode("button", {
            class: "submit_btn _130 _blue",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.callBackModal && $setup.callBackModal(...args)))
          }, "저장")
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.modal.tab,
          title: $setup.modal.title,
          content: $setup.modal.content,
          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: _cache[6] || (_cache[6] = () => {})
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}